import { VendorsView } from "@/features/vendors/components/VendorsView"

export default function VendorsPage() {
  return <VendorsView />
}